import React from "react";
import { useFormContext } from "react-hook-form";

import DailyReportClaimsDetails from "./Claims-Details";
import EmployeeWH from "./EmployeeWH";
import ResourceRecovery from "./ResourceRecovery";
import SubcontractorWH from "./SubcontactorWH";

import useGetFilter from "@/hooks/useGetFilter";
import { ProjectStatus } from "@/interfaces/project.interface";
import { useGetCustomerProjectQuery } from "@/redux/api/projectsQuery";
import { useGetDailyReportTaskBreakDownQuery } from "@/redux/api/reportsQuery";
import { useGetHolidaysQuery } from "@/redux/api/timeTrackingSettingQuery";
import { TDailyReport } from "@/schemas/daily-report.schema";
import { dateFormat } from "@/utils/helper-functions/date-time.helper";

interface DailyReportFormProps {
  id?: string;
}
const DailyReportFormForRoster = (props: DailyReportFormProps): JSX.Element => {
  const { id } = props;
  const form = useFormContext<TDailyReport>();

  const { projectId, customerId } = form.watch();
  const { customerList } = useGetFilter(["customer"]);

  const { data: taskBreakdown, isLoading: isDailyTaskBreakDownFetching } =
    useGetDailyReportTaskBreakDownQuery(
      {
        projectId,
        customerId,
      },
      {
        skip: !projectId || !customerId,
      },
    );

  const { data: allProjects } = useGetCustomerProjectQuery(
    { customerId, projectStatus: ProjectStatus.ONGOING },
    {
      skip: !customerId,
    },
  );

  const projectDetail = React.useMemo(() => {
    return allProjects?.data?.find((project) => project?.id === projectId);
  }, [allProjects, projectId]);

  const projectAddress = projectDetail?.address;

  const { data } = useGetHolidaysQuery({
    filters: "",
  });
  const holidayList = data?.data;

  const holiday = holidayList?.find(
    (d) => dateFormat(d.date) === dateFormat(form.getValues("date") || ""),
  );

  const [customer] = customerList?.filter(
    (item) => item.id === form.watch("customerId"),
  );

  const projects = (allProjects ? allProjects.data : []).filter(
    (item) => item.id === form.watch("projectId"),
  );

  return (
    <section>
      {projects.length > 0 && (
        <div className='p-4 bg-gray-50 rounded-lg shadow-sm mt-5 border'>
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-700'>
            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>Date:</p>
              <p className='font-semibold'>{dateFormat(form.watch("date"))}</p>
            </div>

            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>Customer:</p>
              <p className='font-semibold'>{customer?.label}</p>
            </div>

            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>Project Name:</p>
              <p className='font-semibold'>{projects[0]?.name}</p>
            </div>

            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>Project Address:</p>
              <p className='font-semibold'>{projects[0]?.address.label}</p>
            </div>

            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>
                Customer Project Number:
              </p>
              <p className='font-semibold'>
                {projects[0]?.customerProjectReference}
              </p>
            </div>

            <div className='flex gap-2 items-center'>
              <p className='font-medium text-gray-500'>Our Reference Number:</p>
              <p className='font-semibold'>{projects[0].ourReferenceNumber}</p>
            </div>
          </div>
        </div>
      )}

      <EmployeeWH projectAddress={projectAddress} holiday={holiday} />
      <SubcontractorWH holiday={holiday} />
      <ResourceRecovery id={id ?? ""} />
      {projectId && customerId && !id && (
        <DailyReportClaimsDetails
          data={taskBreakdown || []}
          isLoading={isDailyTaskBreakDownFetching}
        />
      )}
    </section>
  );
};

export default DailyReportFormForRoster;
